/** The sync cards, worded as the planner's Synchronisaties screen. */
export const synchronisaties = {
  status: {
    nooit: "Nog niet gelopen",
    bezig: "Bezig",
    geslaagd: "Geslaagd",
    deelsGelukt: "Deels gelukt",
    mislukt: "Mislukt",
    afwijking: "Afwijking",
  },

  laatsteKeer: "Laatste keer:",
  volgendeKeer: "Volgende keer:",
  nogNietGelopen: "nooit",
  nietIngepland: "niet ingepland in deze omgeving",

  geenAchtergrondservice:
    "De achtergrondservice draait niet. VBS Jury haalt de banen dan niet vanzelf op. Met de knop start je de import wel zelf.",

  import: {
    naam: "Banen uit VBS",
    wat: "De banen van dit jaar, met ploegen, waarnemers, vragen en de VBS-accounts. Dit gebeurt elke zes uur vanzelf.",
    nu: "Nu synchroniseren",
    bezig: "Bezig met synchroniseren",
    mislukt: "De synchronisatie is mislukt.",
    overgeslagen: "Deze banen zijn overgeslagen. De andere banen zijn wel bijgewerkt.",
    done_one: "1 baan geïmporteerd.",
    done_other: "{{count}} banen geïmporteerd.",
    ophalen: "Kon de synchronisatie niet ophalen ({{status}}).",
  },

  push: {
    naam: "Naar VBS",
    wat: "De gekozen antwoorden van elke ploeg. VBS Jury stuurt een ploeg drie minuten na de laatste wijziging vanzelf.",
    nu: "Nu naar VBS sturen",
    bezig: "Bezig met versturen",
    done: "Verstuurd naar VBS.",
    vanzelf: "drie minuten na een wijziging",
    mislukt: "Het versturen is mislukt. VBS Jury probeert het vanzelf opnieuw.",
    ploegFout: "{{ploeg}}, poging {{attempts}}: {{fout}}",
  },
} as const;
